import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { useLocale } from 'locale';
import { State } from 'store/state';
import { authModalStatusSelector, contactModalPoiIdSelector, hostedFieldsModalStateSelector } from 'store/state/app/selectors';
import { ShowAt, useScreenBreakpoint } from 'consts/breakpoints';
import { PoiId } from 'utils/entities';

import ContactModal from 'components/contact-modal';
import FeedbackPopup from 'components/feedback-popup';
import ReportListingPopup from 'components/report-listing-popup';
import ReportUploadBulletinPopup from 'components/upload-bulletin/report-error-popup';
import AfterUploadBulletinModal from 'components/upload-bulletin/after-upload-modal';
import AddressFeedBackPopUp from 'components/address-feedback/AddressFeedBackPopup';
import { ContactAgentSuccessPopup } from 'components/contact-modal/success-popup';
import UgcFeedbackModal from 'components/user-generated-content/connected-components/feedback-modal';
import UgcGratitudeModal from 'components/user-generated-content/gratitude-modal';
import UgcReviewWizard from 'components/user-generated-content/connected-components/review-wizard';
import UgcShareReviewModal from 'components/user-generated-content/share-review-modal';
import MadadContactModal from 'components/madad/contact-modal';
import { withIdleCallback } from 'hocs/withIdleCallback';
import AuthenticationModal from 'components/authentication';
import FeedbackToast from 'components/feedback-toast';
import { AuthenticationModalType } from 'components/authentication/types';
import ManageListingsErrorModal from 'components/bulletin-form/wizard/ErrorModal';
import UpdateListingStatusPopup from 'components/update-listing-status-popup';
import MizrahiBankModal from 'components/mizrahi-bank-modal';
import MobileDiscovery from 'components/mobile-discovery';
import { insideReactNative } from 'react-native/lib/platform';
import { isAndroid, isIOS } from 'utils/uaMatchers';
import { UserAgentContext } from 'hooks/useImageUrlBuilder';
import { mobileDiscoveryPopupStatusSelector } from 'store/state/app/selectors';
import { PushNotificationsDrawerConnected } from 'components/push-notifications-drawer';
import DealAffiliationPopup from 'components/deal-affiliation-popup';
import PrivateBulletinHasAlreadyBeenPromotedModal from 'components/private-bulletin-promotion/modals/PrivateBulletinHasAlreadyBeenPromotedModal';
import PrivateBulletinSuccesfullyPromotedModal from 'components/private-bulletin-promotion/modals/PrivateBulletinSuccesfullyPromotedModal';
import AgentSupportModal from 'components/support/AgentSupportModal';
import YieldModal from 'components/yield-tag-modal';
import PrivateBulletinSelectPromotionPlanModal from 'components/private-bulletin-promotion/modals/private-bulletin-select-promotion-plan-modal';
import { PrivateBulletinMinimumPromotionPlanModal } from 'components/private-bulletin-promotion/modals/private-bulletin-minimum-promotion-plan-modal';
import PaymentResultModal from 'components/payment/PaymentResultModal';
import RedeemPromotionPlanGrantResultModal from 'components/payment/RedeemPromotionPlanGrantResultModal';
import CancelUserPromotionPlanResultModal from 'components/payment/CancelUserPromotionPlanResultModal';
import { PrivateBulletinPlanLoadingModal } from 'components/private-bulletin-promotion/modals/loading';
import UnapprovedAgentPopup from 'components/unapproved-agent-popup/UnapprovedAgentPopup';
import NotificationBannerContainer from 'components/notification-banner/NotificationBannerContainer';
import { InvestorsCompareModal } from 'screens/Investors/components/CompareModal';
import { CookiesPopup } from 'components/cookies-popup';
import TranzilaHostedFieldsModal from 'components/tranzila-hosted-fields';
import { PaymentFailModal } from 'components/tranzila-hosted-fields/modals/FailModal';
import { PaymentFailUploadModal } from 'components/tranzila-hosted-fields/modals/FailUploadModal';
import { PaymentSuccessModal } from 'components/tranzila-hosted-fields/modals/SuccessModal';
import { PaymentSuccessUploadModal } from 'components/tranzila-hosted-fields/modals/SuccessUploadModal';
import { TranzilaModalState } from 'components/tranzila-hosted-fields/types';
import { AfterDeleteListingModal } from 'components/manage-bulletin/after-delete-modal';

const AddressFeedBackPopUpWhenIdle = withIdleCallback(AddressFeedBackPopUp);
const AuthenticatioModalWhenIdle = withIdleCallback(AuthenticationModal);
const ContactModalWhenIdle = withIdleCallback(ContactModal);
const ContactAgentSuccessPopupWhenIdle = withIdleCallback(ContactAgentSuccessPopup);
const FeedbackPopupWhenIdle = withIdleCallback(FeedbackPopup);
const FeedbackToastWhenIdle = withIdleCallback(FeedbackToast);
const ReportListingPopupWhenIdle = withIdleCallback(ReportListingPopup);
const ReportUploadBulletinAddressErrorPopupWhenIdle = withIdleCallback(ReportUploadBulletinPopup);
const AfterUploadBulletinModalWhenIdle = withIdleCallback(AfterUploadBulletinModal);
const UgcFeedbackModalWhenIdle = withIdleCallback(UgcFeedbackModal);
const UgcGratitudeModalWhenIdle = withIdleCallback(UgcGratitudeModal);
const UgcShareReviewModalWhenIdle = withIdleCallback(UgcShareReviewModal);
const UgcReviewWizardWhenIdle = withIdleCallback(UgcReviewWizard);
const MadadContactModalWhenIdle = withIdleCallback(MadadContactModal);
const ManageListingsErrorModalWhenIdle = withIdleCallback(ManageListingsErrorModal);
const UpdateListingStatusPopupWhenIdle = withIdleCallback(UpdateListingStatusPopup);
const MizrahiBankModalWhenIdle = withIdleCallback(MizrahiBankModal);
const YieldModalWhenIdle = withIdleCallback(YieldModal);
const MobileDiscoveryModalWhenIdle = withIdleCallback(MobileDiscovery);
const PushNotificationsDrawerWhenIdle = withIdleCallback(PushNotificationsDrawerConnected);
const DealAffiliationModalWhenIdle = withIdleCallback(DealAffiliationPopup);
const PaymentResultModalWhenIdle = withIdleCallback(PaymentResultModal);
const RedeemPromotionPlanGrantResultModalWhenIdle = withIdleCallback(RedeemPromotionPlanGrantResultModal);
const CancelUserPromotionPlanResultModalWhenIdle = withIdleCallback(CancelUserPromotionPlanResultModal);
const PrivateBulletinHasAlreadyBeenPromotedModalWhenIdle = withIdleCallback(PrivateBulletinHasAlreadyBeenPromotedModal);
const PrivateBulletinSelectPromotionPlanModalWhenIdle = withIdleCallback(PrivateBulletinSelectPromotionPlanModal);
const PrivateBulletinMinimumPromotionPlanModalWhenIdle = withIdleCallback(PrivateBulletinMinimumPromotionPlanModal);
const PrivateBulletinPlanLoadingModalWhenIdle = withIdleCallback(PrivateBulletinPlanLoadingModal);
const PrivateBulletinSuccesfullyPromotedModalWhenIdle = withIdleCallback(PrivateBulletinSuccesfullyPromotedModal);
const AgentSupportModalWhenIdle = withIdleCallback(AgentSupportModal);
const UnapprovedAgentModalWhenIdle = withIdleCallback(UnapprovedAgentPopup);
const NotificationBannerContainerWhenIdle = withIdleCallback(NotificationBannerContainer);
const InvestorsCompareModalWhenIdle = withIdleCallback(InvestorsCompareModal);
const CookiesModalWhenIdle = withIdleCallback(CookiesPopup);
const HostedFieldsModalWhenIdle = withIdleCallback(TranzilaHostedFieldsModal);
const PaymentFailModalWhenIdle = withIdleCallback(PaymentFailModal);
const PaymentFailUploadModalWhenIdle = withIdleCallback(PaymentFailUploadModal);
const PaymentSuccessModalWhenIdle = withIdleCallback(PaymentSuccessModal);
const PaymentSuccessUploadModalWhenIdle = withIdleCallback(PaymentSuccessUploadModal);
const AfterDeleteListingModalWhenIdle = withIdleCallback(AfterDeleteListingModal);

interface ModalsProps {
  authModal: AuthenticationModalType;
  contactModalPoiId: PoiId;
  discoveryIsOpen: boolean;
  hostedFieldsModalState: TranzilaModalState | null;
}

const appleStoreLink = 'https://apps.apple.com/ua/app/madlan/id6472173076';
const playMarketLink = 'https://play.google.com/store/apps/details?id=com.madlanmobclient';

const Modals: React.FC<ModalsProps> = (props) => {
  const { authModal, contactModalPoiId, discoveryIsOpen, hostedFieldsModalState } = props;
  const { t } = useLocale();
  const isInsideRN = insideReactNative();
  const currentRange = useScreenBreakpoint();
  const isMobileView = currentRange <= 2;
  const userAgent = useContext(UserAgentContext);
  const isIOSDevice = isIOS(userAgent);
  const isAndroidDevice = isAndroid(userAgent);
  const isMobileDevice = isIOSDevice || isAndroidDevice;
  const marketLink = isAndroidDevice ? playMarketLink : appleStoreLink;

  if (!isInsideRN && isMobileView && isMobileDevice && discoveryIsOpen && !hostedFieldsModalState) return <MobileDiscoveryModalWhenIdle marketLink={marketLink} />;

  return (
    <>
      {authModal ? <AuthenticatioModalWhenIdle /> : null}

      <AgentSupportModalWhenIdle />

      {contactModalPoiId ? <ContactModalWhenIdle /> : null}
      <ContactAgentSuccessPopupWhenIdle />

      <MadadContactModalWhenIdle />
      <FeedbackPopupWhenIdle
        popupTitle={t('feedback.popup.title')}
        submitButtonText={t('feedback.popup.submit')}
      />
      <AddressFeedBackPopUpWhenIdle
        popupTitle={t('feedback.popup.title')}
        submitButtonText={t('addressPage.feedback.submit')}
      />
      <ReportListingPopupWhenIdle
        popupTitle={t('reportListing.popup.title')}
        submitButtonText={t('reportListing.popup.button.text')}
      />
      <ReportUploadBulletinAddressErrorPopupWhenIdle />

      <UgcFeedbackModalWhenIdle />
      <UgcGratitudeModalWhenIdle />
      <UgcShareReviewModalWhenIdle />
      <UgcReviewWizardWhenIdle />
      <AfterUploadBulletinModalWhenIdle />
      <ManageListingsErrorModalWhenIdle />
      <UpdateListingStatusPopupWhenIdle />
      <MizrahiBankModalWhenIdle />
      <YieldModalWhenIdle />
      <PushNotificationsDrawerWhenIdle />
      <DealAffiliationModalWhenIdle />

      <PaymentResultModalWhenIdle />
      <RedeemPromotionPlanGrantResultModalWhenIdle />
      <CancelUserPromotionPlanResultModalWhenIdle />

      <PrivateBulletinHasAlreadyBeenPromotedModalWhenIdle />
      <PrivateBulletinSuccesfullyPromotedModalWhenIdle />
      <PrivateBulletinSelectPromotionPlanModalWhenIdle />
      <PrivateBulletinMinimumPromotionPlanModalWhenIdle />
      <PrivateBulletinPlanLoadingModalWhenIdle />

      <UnapprovedAgentModalWhenIdle />

      <NotificationBannerContainerWhenIdle />

      <InvestorsCompareModalWhenIdle />

      <ShowAt from={3}>
        {isDesktop => <FeedbackToastWhenIdle isDesktop={isDesktop} />}
      </ShowAt>
      <CookiesModalWhenIdle />
      <HostedFieldsModalWhenIdle />
      <PaymentFailModalWhenIdle />
      <PaymentFailUploadModalWhenIdle />
      <PaymentSuccessModalWhenIdle />
      <PaymentSuccessUploadModalWhenIdle />
      <AfterDeleteListingModalWhenIdle />
    </>
  );
};

const mapStateToProps = (state: State) => ({
  authModal: authModalStatusSelector(state),
  contactModalPoiId: contactModalPoiIdSelector(state),
  discoveryIsOpen: mobileDiscoveryPopupStatusSelector(state),
  hostedFieldsModalState: hostedFieldsModalStateSelector(state),
});

export default connect(mapStateToProps)(Modals);
